(function () {
    'use strict';

    angular.module('app.collections', [
        // Angular modules 
        'ngRoute',
        'ngFileUpload'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();